import * as Yup from "yup";
import { CONFIRM_PASSWORD_REQUIRED, FIRST_NAME_REQUIRED, LAST_NAME_REQUIRED, NEW_PASSWORD_SHOULD_DIFF, PASSWORD_MUST_MATCH, PASSWORD_REGEX, PASSWORD_REQUIRED, PASSWORD_STRENGTH } from "../../helpers/validation.messages";

export const ProfilePageSchema = Yup.object({
    firstname: Yup.string().required(FIRST_NAME_REQUIRED).trim(),
    lastname: Yup.string().required(LAST_NAME_REQUIRED).trim(),
});


export const ChangePasswordPageSchema = Yup.object({
    current_password: Yup.string().required(PASSWORD_REQUIRED).trim(),
    new_password: Yup.string()
        .required(PASSWORD_REQUIRED)
        .trim()
        // .min(PASSWORD_MIN_CHAR, MIN_CHAR_LENGTH)
        .matches(PASSWORD_REGEX, PASSWORD_STRENGTH)
        .notOneOf([Yup.ref("current_password")], NEW_PASSWORD_SHOULD_DIFF),
    confirm_password: Yup.string()
        .oneOf([Yup.ref("new_password"), ""], PASSWORD_MUST_MATCH)
        .required(CONFIRM_PASSWORD_REQUIRED),
});
